const FALLBACK = "Something went wrong. Please try again.";

const containsHtml = (value: string): boolean =>
  /<html/i.test(value) || /<!DOCTYPE/i.test(value);

type ApiError = {
  status?: number;
  response?: { status?: number };
  body?: { message?: string };
  data?: { message?: string };
  message?: string;
};

export const getApiErrorMessage = (error: unknown, fallback = FALLBACK): string => {
  const err = error as ApiError;

  // Gateway/server errors — never show raw responses to users
  const status = err?.status ?? err?.response?.status;
  if (typeof status === "number" && status >= 500) return fallback;

  const raw =
    err?.body?.message ||
    err?.data?.message ||
    err?.message ||
    "";

  if (!raw || containsHtml(raw)) return fallback;

  return raw;
};
